import styled from '@emotion/styled';

export const ItemsListContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    row-gap: 2rem;
`;
